import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToggleButtonComponent} from './toggle-button/toggle-button.component';
import {InputComponent} from './input/input.component';
import {AccentButtonComponent} from './accent-button/accent-button.component';
import {SliderComponent} from './slider/slider.component';
import {HeaderComponent} from './header/header.component';
import {BigHeaderComponent} from './big-header/big-header.component';
import {BackToTopButtonComponent} from './back-to-top-button/back-to-top-button.component';


@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [ToggleButtonComponent, BackToTopButtonComponent, InputComponent, AccentButtonComponent, SliderComponent, BigHeaderComponent, HeaderComponent],
    exports: [ToggleButtonComponent, BackToTopButtonComponent, InputComponent, AccentButtonComponent, SliderComponent, BigHeaderComponent, HeaderComponent]
})
export class BaseModule {
}
